import { SAGA_ACTIONS } from "../../constants";
import { useApiCall } from "../common/appApiCallHook";



export function thirdPartyApi() {

    const callApi = useApiCall();

    const quickBookAuth = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.AUTH, data, onSuccess, onError);
    }
    const quickBookCallback = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.CALLBACK, data, onSuccess, onError);
    }
    const quickBookImportData = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.IMPORT_DATA, data, onSuccess, onError);
    }
    const fetchQuickBookAccountCharts = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.FETCH_ACCOUNT_CHARTS, data, onSuccess, onError);
    }
    const postQuickBookAccountCharts = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.POST_ACCOUNT_CHARTS, data, onSuccess, onError);
    }
    const fetchQboClassificationMap = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.CLASSIFICATION_MAP, data, onSuccess, onError);
    }
    const matchQboParent = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.PARENT_MATCH, data, onSuccess, onError);
    }
    const qbFetchOpenningAcc = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.QB_FETCH_OPENNING_BALANCE, data, onSuccess, onError);
    }
    const postQuickBookBeginningBalance = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.QB_POST_OPENNING_BALANCE, data, onSuccess, onError);
    }
    const qbFetchBSPL = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.QB_FETCH_BS_PL, data, onSuccess, onError);
    }
    const qbPostBSPL = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.QB_POST_BS_PL, data, onSuccess, onError);
    }
    const qbFetchBS = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.QB_FETCH_BS, data, onSuccess, onError);
    }
    const qbFetchPL = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.QB_FETCH_PL, data, onSuccess, onError);
    }
    const qbFetchVendors = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.QB_FETCH_VENDORS, data, onSuccess, onError);
    }
    const qbFetchCustomers = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.QB_FETCH_CUSTOMERS, data, onSuccess, onError);
    }


    const qbFetchJobStatus = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.QB_JOB_STATUS, data, onSuccess, onError);
    }
    const qbAcknowledgeJobWarnings = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.QB_ACKNOWLEDGE_JOB_WARNINGS, data, onSuccess, onError);
    }
    const qbFetchImportJobStatus = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.QB_IMPORT_JOB_STATUS, data, onSuccess, onError);
    }
    const qbFetchBackupLatest = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.QBO_BACKUP_LATEST, data, onSuccess, onError);
    }
    const qbFetchBackupStatus = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.QBO_BACKUP_STATUS, data, onSuccess, onError);
    }
    const qbRetryBackup = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.QBO_BACKUP_RETRY, data, onSuccess, onError);
    }
    const qbFetchLedgerAudit = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.QB_LEDGER_AUDIT, data, onSuccess, onError);
    }
    const qbRetryLedgerPeriod = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.QB_LEDGER_RETRY, data, onSuccess, onError);
    }
    const qbRetryLedgerPeriods = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.QB_LEDGER_RETRY_ALL, data, onSuccess, onError);
    }
    const qbSaveLedgerMappings = (data: any, onSuccess: Function, onError: Function) => {
        callApi(SAGA_ACTIONS.QUICK_BOOK.QB_LEDGER_MAPPINGS, data, onSuccess, onError);
    }
    return {
        quickBookAuth,
        quickBookCallback,
        quickBookImportData,
        fetchQuickBookAccountCharts,
        postQuickBookAccountCharts,
        fetchQboClassificationMap,
        matchQboParent,
        qbFetchOpenningAcc,
        postQuickBookBeginningBalance,
        qbFetchBSPL,
        qbPostBSPL,
        qbFetchBS,
        qbFetchPL,
        qbFetchVendors,
        qbFetchCustomers,
        qbFetchJobStatus,
        qbAcknowledgeJobWarnings,
        qbFetchImportJobStatus,
        qbFetchBackupLatest,
        qbFetchBackupStatus,
        qbRetryBackup,
        qbFetchLedgerAudit,
        qbRetryLedgerPeriod,
        qbRetryLedgerPeriods,
        qbSaveLedgerMappings,
    }
}
